import * as Yup from 'yup';

export const AccountSettingsFormValidationSchema = Yup.object().shape({
  currentPass: Yup.string()
    .nullable()
    .when(['newPass', 'confirmPass'], (newPass, confirmPass, schema) =>
      !!newPass || !!confirmPass
        ? schema.required(
            'Please input your current password to change password'
          )
        : schema
    ),

  newPass: Yup.string()
    .nullable()
    .min(6, 'Password is too short. Minimum length is 6 characters.')
    .max(100, 'Password is too long. Maximum length is 20 characters.'),

  confirmPass: Yup.string()
    .nullable()
    .when(['newPass'], (newPass, schema) =>
      schema.test('match-newPass', "Passwords don't match", value =>
        newPass && newPass.length > 0 ? value && newPass === value : true
      )
    ),

  CandidatePremiumAutoRenew: Yup.string()
    .nullable()
    .when(['AutoRenewCreditCardID'], (AutoRenewCreditCardID, schema) =>
      schema.test(
        'test-CandidatePremiumAutoRenew',
        'You need to select stored credit card for auto renew payments',
        value => (value === 'Yes' ? !!AutoRenewCreditCardID : true)
      )
    ),

  AlternateEmail: Yup.string()
    .nullable()
    .when(
      ['ReceiveApplicationAlternate'],
      (ReceiveApplicationAlternate, schema) =>
        ReceiveApplicationAlternate === 'Yes'
          ? schema
              .email('Email address is incorrect')
              .required('This field is required')
          : schema
    ),

  JobMailingAlternateEmail: Yup.string()
    .nullable()
    .when(
      ['JobMailingAlternateEmailActive'],
      (JobMailingAlternateEmailActive, schema) =>
        JobMailingAlternateEmailActive === 'Yes'
          ? schema
            .email('Email address is incorrect')
            .required('This field is required')
          : schema
    ),

  ProcessDigestAlternateEmail: Yup.string()
    .nullable()
    .when(
      ['ReceiveProcessDigestAlternate'],
      (ReceiveProcessDigestAlternate, schema) =>
        ReceiveProcessDigestAlternate === 'Yes'
          ? schema
              .email('Email address is incorrect')
              .required('This field is required')
          : schema
    ),
});
